import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';
import Image from '@/components/route/blog/BlogPostImage/Image';
import Heading from '@/components/switchback/Heading/Heading';
import Link from '@/components/switchback/Link/Link';
import { IBlogPost } from '@/services/types/blog/post.types';

import css from './SuggestedPosts.module.css';

interface ICategoryPost {
  posts: IBlogPost[];
}

const CategoryPosts: React.FC<ICategoryPost> = ({ posts }) => {
  return (
    <div
      className={`w-full mx-auto mt-4 grid gap-0 lg:gap-5 lg:max-w-none grid-cols-1 lg:grid-cols-1 ${css.wrapper}`}>
      {posts.map(p => (
        <div key={p.slug} className={`${css.card}`}>
          <Link legacy href="/blog/[blogPostSlug]" as={`/blog/${p.slug}`}>
            <a href={`/blog/${p.slug}`} className="block">
              <AspectRatio ratio="4:3" hasImageHover={false} className="h-full">
                <Image images={p.images} title={p.title || 'Outdoorsy Suggested Blog Post Image'} />
              </AspectRatio>
            </a>
          </Link>
          {!!p.title && (
            <div className="py-2">
              <Heading level={3} className="highlight autoType400">
                <Link legacy href="/blog/[blogPostSlug]" as={`/blog/${p.slug}`}>
                  <a href={`/blog/${p.slug}`}>
                    <span dangerouslySetInnerHTML={{ __html: p.title }} />
                  </a>
                </Link>
              </Heading>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryPosts;
